import {
  CurrentContextInfo,
  LsZmCollectionAssetsMessage,
  LsZmCollectionAssetsQuery,
  LsZmCollectionAssetsResponse
} from '../../../autogenerated/ZoomBridge';
import CollectionUtil from '../CollectionUtil';
import Authenticator from '../../../protocol/Authenticator';
import HashMap from '../../../protocol/HashMap';
import SaveSettings from '../../settings/SaveSettings';
export default class LsZmCollectionAssets {
  /**
   *
   * @param collectionId
   */

  _collectionId: number;
  _sortCriteria: string;
  _sortOrder: string;
  _currentContextInfo: CurrentContextInfo;
  _pageLimit: number;

  constructor(collectionId) {
    this._collectionId = collectionId;
    this._pageLimit = 1000;
  }

  /**
   *
   * @param collectionId
   * Get sort criteria and sort order of collection
   * Run LsZmCollectionAssets query
   */

  getSortSettingsAndRunQuery = async (): Promise<LsZmCollectionAssetsResponse> => {
    try {
      const propName2ValueMap: HashMap = await CollectionUtil.getCollectionSettings(
        this._collectionId,
        Authenticator.AUTH_DATA.username,
        this._doNoUserAuthenticator
      );
      if (propName2ValueMap) {
        let sortCriteriaValue: string = propName2ValueMap.get(CollectionUtil.COLLECTION_SETTINGS.SORT_CRITERIA);
        let sortOrderValue: string = propName2ValueMap.get(CollectionUtil.COLLECTION_SETTINGS.SORT_ORDER);
        this._sortCriteria = sortCriteriaValue
          ? sortCriteriaValue
          : CollectionUtil.getCollectionAssetGlobalSortCriteria();
        if (sortOrderValue) {
          this._sortOrder = sortOrderValue === 'ASCENDING' ? 0 : 1;
        } else {
          this._sortOrder = CollectionUtil.getCollectionAssetGlobalSortOrder();
        }
        this.setCurrentContextInfo();
        return this.runLsZmCollectionAssetsQuery();
      } else {
        this._sortCriteria = CollectionUtil.getCollectionAssetGlobalSortCriteria();
        this._sortOrder = CollectionUtil.getCollectionAssetGlobalSortOrder();
        this.setCurrentContextInfo();
        return this.runLsZmCollectionAssetsQuery();
      }
    } catch (err) {
      this._sortCriteria = CollectionUtil.getCollectionAssetGlobalSortCriteria();
      this._sortOrder = CollectionUtil.getCollectionAssetGlobalSortOrder();
      this.setCurrentContextInfo();
      return this.runLsZmCollectionAssetsQuery();
    }
  };

  setCurrentContextInfo() {
    this._currentContextInfo = new CurrentContextInfo();
    this._currentContextInfo.setSortCriteria(this._sortCriteria);
    this._currentContextInfo.setOrder(this._sortOrder);
  }

  runLsZmCollectionAssetsQuery(): Promise<LsZmCollectionAssetsResponse> {
    const query = new LsZmCollectionAssetsQuery();
    const message = new LsZmCollectionAssetsMessage();
    message.setCollectionId(this._collectionId);
    message.setPageLimit(this._pageLimit);
    message.setCurrentContextInfo(this._currentContextInfo);
    message.setShowDeleted(SaveSettings.getBoolean(SaveSettings.FIND_SEARCH_SHOW_DELETED));
    message.setShowArchived(SaveSettings.getBoolean(SaveSettings.FIND_SEARCH_SHOW_ARCHIVED));
    message.setShowExpired(SaveSettings.getBoolean(SaveSettings.FIND_SEARCH_SHOW_EXPIRED));
    if (this.fuidFilters) {
      message.setFuidFilters(this.fuidFilters);
    }
    query.message = message;
    if (this._doNoUserAuthenticator) {
      query.setAuthenticator(null);
    }
    return query.run();
  }

  /**
   * Sets up paging parameters
   */

  setPageLimit(pageLimit) {
    this._pageLimit = pageLimit;
    return this;
  }

  setCollectionId(collectionId) {
    this._collectionId = collectionId;
    return this;
  }

  doNoUserAuthenticator() {
    this._doNoUserAuthenticator = true;
  }

  /**
   * @param  {Array.<number>} fuidFilters
   * @return {LsZmCollectionAssets}
   */
  setFuidFilter(fuidFilters) {
    this.fuidFilters = fuidFilters;
    return this;
  }

  /**
   * Returns array of assets to callback
   * @return {Promise.<>}
   */
  run(progress = true) {
    return new Promise((resolve, reject) => {
      if (this._doNoUserAuthenticator) {
        this._currentContextInfo = new CurrentContextInfo();
        this._currentContextInfo.setSortCriteria(CollectionUtil.getCollectionAssetGlobalSortCriteria());
        this._currentContextInfo.setOrder(CollectionUtil.getCollectionAssetGlobalSortOrder());
        this.runLsZmCollectionAssetsQuery()
          .then((resp) => {
            resolve(resp);
          })
          .catch((error) => {
            reject(error);
          });
      } else {
        this.getSortSettingsAndRunQuery()
          .then((resp) => {
            resolve(resp);
          })
          .catch((error) => {
            reject(error);
          });
      }
    });
  }
}
